export default __webpack_public_path__ + "static/media/dorcspark.2b048035.png";